module.exports = __webpack_public_path__ + "img/C03TechSpearman_ua.eb2fff92.webp";